module.exports = __webpack_public_path__ + "img/logo.646bb401.svg";